import { motion, useReducedMotion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * A count that « jumps » when it changes, so a number moving under the eye is noticed without
 * reloading (« T'attend » en direct, 01/10/2026). Nothing moves at the first paint nor when the
 * system asks for reduced motion.
 */
export function CountPop({ value, className }: { value: number | string; className?: string }) {
  const reduce = useReducedMotion();
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
  }, []);
  return (
    <motion.span
      key={String(value)}
      initial={reduce || !mounted.current ? false : { scale: 1.45 }}
      animate={{ scale: 1 }}
      transition={{ type: 'spring', stiffness: 520, damping: 18 }}
      className={twMerge('inline-block tabular-nums', className)}
    >
      {value}
    </motion.span>
  );
}
